module.exports = __webpack_public_path__ + "media/images/country_flags/es-5c871b9f418983220d9977c5bb5845da.png";